import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@fluentui/react/lib/Text';
import { IconButton } from '@fluentui/react/lib/Button';

const PageHeading = ({ title, children, isBackButton, backButtonOnClick }) => (
  <div className="component_page-heading">
    {isBackButton && (
      <IconButton
        iconProps={{ iconName: 'Back' }}
        onClick={backButtonOnClick}
        className="back-button"
      />
    )}
    <Text as="h2">{title}</Text>
    {children}
  </div>
);

PageHeading.defaultProps = {
  title: '',
  children: <span />,
  backButtonOnClick: () => {},
  isBackButton: false,
};

PageHeading.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isBackButton: PropTypes.bool,
  backButtonOnClick: PropTypes.func,
};

export default PageHeading;
